// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AgbRouteImport } from './routes/agb'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as ApplicationsRouteImport } from './routes/applications'
import { Route as BarrierefreiheitRouteImport } from './routes/barrierefreiheit'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as CoverLettersRouteImport } from './routes/cover-letters'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as DeepMatchRouteImport } from './routes/deep-match'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as InterviewPrepRouteImport } from './routes/interview-prep'
import { Route as KeywordOptimizerRouteImport } from './routes/keyword-optimizer'
import { Route as KuendigungRouteImport } from './routes/kuendigung'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NegotiationRouteImport } from './routes/negotiation'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PortalScannerRouteImport } from './routes/portal-scanner'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ReferralRouteImport } from './routes/referral'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SalaryRouteImport } from './routes/salary'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StoryBankRouteImport } from './routes/story-bank'
import { Route as UniversityRouteImport } from './routes/university'
import { Route as VpatRouteImport } from './routes/vpat'
import { Route as WiderrufRouteImport } from './routes/widerruf'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as AnalyticsActivityRouteImport } from './routes/analytics/activity'
import { Route as AnalyticsResumePerformanceRouteImport } from './routes/analytics/resume-performance'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as CoverLettersCoverIdRouteImport } from './routes/cover-letters/$coverId'
import { Route as DeAtsLebenslaufAnforderungenBelegenRouteImport } from './routes/de.ats-lebenslauf-anforderungen-belegen'
import { Route as DeLebenslaufGeneratorDin5008RouteImport } from './routes/de.lebenslauf-generator-din-5008'
import { Route as EnChancenkarteResumeBuilderRouteImport } from './routes/en.chancenkarte-resume-builder'
import { Route as GehaltIndexRouteImport } from './routes/gehalt/index'
import { Route as GehaltBerufRouteImport } from './routes/gehalt/$beruf'
import { Route as InterviewPrepIndexRouteImport } from './routes/interview-prep/index'
import { Route as InterviewPrepPracticeRouteImport } from './routes/interview-prep/practice'
import { Route as InterviewPrepQuestionBankRouteImport } from './routes/interview-prep/question-bank'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as JobsJobIdRouteImport } from './routes/jobs/$jobId'
import { Route as JobsNewRouteImport } from './routes/jobs/new'
import { Route as JobsScrapedRouteImport } from './routes/jobs/scraped'
import { Route as JobsSearchCriteriaRouteImport } from './routes/jobs/search-criteria'
import { Route as ResumesIndexRouteImport } from './routes/resumes/index'
import { Route as ResumesResumeIdRouteImport } from './routes/resumes/$resumeId'
import { Route as ResumesNewRouteImport } from './routes/resumes/new'
import { Route as SalaryIndexRouteImport } from './routes/salary/index'
import { Route as SalaryNegotiateRouteImport } from './routes/salary/negotiate'
import { Route as SharedShareTokenRouteImport } from './routes/shared/$shareToken'
import { Route as SkillsIndexRouteImport } from './routes/skills/index'
import { Route as SkillsOccupationRouteImport } from './routes/skills/$occupation'
import { Route as UniSlugRouteImport } from './routes/uni/$slug'
import { Route as UniversityIndexRouteImport } from './routes/university/index'
import { Route as UniversityDashboardRouteImport } from './routes/university/dashboard'
import { Route as BlogCitiesSlugRouteImport } from './routes/blog/cities.$slug'
import { Route as BlogCountriesCodeRouteImport } from './routes/blog/countries.$code'
import { Route as BlogPillarSlugRouteImport } from './routes/blog/pillar.$slug'
import { Route as BlogRolesSlugRouteImport } from './routes/blog/roles.$slug'
import { Route as BlogTagsTagRouteImport } from './routes/blog/tags.$tag'
import { Route as BlogUniversitiesSlugRouteImport } from './routes/blog/universities.$slug'
import { Route as BlogVisaSlugRouteImport } from './routes/blog/visa.$slug'
import { Route as GehaltBerufBundeslandRouteImport } from './routes/gehalt/$beruf.$bundesland'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AgbRoute = AgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const ApplicationsRoute = ApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => rootRouteImport
          })
const BarrierefreiheitRoute = BarrierefreiheitRouteImport.update({
            id: '/barrierefreiheit',path: '/barrierefreiheit',getParentRoute: () => rootRouteImport
          })
const BillingRoute = BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => rootRouteImport
          })
const CoverLettersRoute = CoverLettersRouteImport.update({
            id: '/cover-letters',path: '/cover-letters',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const DeepMatchRoute = DeepMatchRouteImport.update({
            id: '/deep-match',path: '/deep-match',getParentRoute: () => rootRouteImport
          })
const FeedbackRoute = FeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const InterviewPrepRoute = InterviewPrepRouteImport.update({
            id: '/interview-prep',path: '/interview-prep',getParentRoute: () => rootRouteImport
          })
const KeywordOptimizerRoute = KeywordOptimizerRouteImport.update({
            id: '/keyword-optimizer',path: '/keyword-optimizer',getParentRoute: () => rootRouteImport
          })
const KuendigungRoute = KuendigungRouteImport.update({
            id: '/kuendigung',path: '/kuendigung',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const NegotiationRoute = NegotiationRouteImport.update({
            id: '/negotiation',path: '/negotiation',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PortalScannerRoute = PortalScannerRouteImport.update({
            id: '/portal-scanner',path: '/portal-scanner',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ReferralRoute = ReferralRouteImport.update({
            id: '/referral',path: '/referral',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const SalaryRoute = SalaryRouteImport.update({
            id: '/salary',path: '/salary',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const StoryBankRoute = StoryBankRouteImport.update({
            id: '/story-bank',path: '/story-bank',getParentRoute: () => rootRouteImport
          })
const UniversityRoute = UniversityRouteImport.update({
            id: '/university',path: '/university',getParentRoute: () => rootRouteImport
          })
const VpatRoute = VpatRouteImport.update({
            id: '/vpat',path: '/vpat',getParentRoute: () => rootRouteImport
          })
const WiderrufRoute = WiderrufRouteImport.update({
            id: '/widerruf',path: '/widerruf',getParentRoute: () => rootRouteImport
          })
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AnalyticsRoute
          })
const AnalyticsActivityRoute = AnalyticsActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AnalyticsRoute
          })
const AnalyticsResumePerformanceRoute = AnalyticsResumePerformanceRouteImport.update({
            id: '/resume-performance',path: '/resume-performance',getParentRoute: () => AnalyticsRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/auth/forgot-password',path: '/auth/forgot-password',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/auth/reset-password',path: '/auth/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/auth/signup',path: '/auth/signup',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CoverLettersCoverIdRoute = CoverLettersCoverIdRouteImport.update({
            id: '/$coverId',path: '/$coverId',getParentRoute: () => CoverLettersRoute
          })
const DeAtsLebenslaufAnforderungenBelegenRoute = DeAtsLebenslaufAnforderungenBelegenRouteImport.update({
            id: '/de/ats-lebenslauf-anforderungen-belegen',path: '/de/ats-lebenslauf-anforderungen-belegen',getParentRoute: () => rootRouteImport
          })
const DeLebenslaufGeneratorDin5008Route = DeLebenslaufGeneratorDin5008RouteImport.update({
            id: '/de/lebenslauf-generator-din-5008',path: '/de/lebenslauf-generator-din-5008',getParentRoute: () => rootRouteImport
          })
const EnChancenkarteResumeBuilderRoute = EnChancenkarteResumeBuilderRouteImport.update({
            id: '/en/chancenkarte-resume-builder',path: '/en/chancenkarte-resume-builder',getParentRoute: () => rootRouteImport
          })
const GehaltIndexRoute = GehaltIndexRouteImport.update({
            id: '/gehalt/',path: '/gehalt/',getParentRoute: () => rootRouteImport
          })
const GehaltBerufRoute = GehaltBerufRouteImport.update({
            id: '/gehalt/$beruf',path: '/gehalt/$beruf',getParentRoute: () => rootRouteImport
          })
const InterviewPrepIndexRoute = InterviewPrepIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => InterviewPrepRoute
          })
const InterviewPrepPracticeRoute = InterviewPrepPracticeRouteImport.update({
            id: '/practice',path: '/practice',getParentRoute: () => InterviewPrepRoute
          })
const InterviewPrepQuestionBankRoute = InterviewPrepQuestionBankRouteImport.update({
            id: '/question-bank',path: '/question-bank',getParentRoute: () => InterviewPrepRoute
          })
const JobsIndexRoute = JobsIndexRouteImport.update({
            id: '/jobs/',path: '/jobs/',getParentRoute: () => rootRouteImport
          })
const JobsJobIdRoute = JobsJobIdRouteImport.update({
            id: '/jobs/$jobId',path: '/jobs/$jobId',getParentRoute: () => rootRouteImport
          })
const JobsNewRoute = JobsNewRouteImport.update({
            id: '/jobs/new',path: '/jobs/new',getParentRoute: () => rootRouteImport
          })
const JobsScrapedRoute = JobsScrapedRouteImport.update({
            id: '/jobs/scraped',path: '/jobs/scraped',getParentRoute: () => rootRouteImport
          })
const JobsSearchCriteriaRoute = JobsSearchCriteriaRouteImport.update({
            id: '/jobs/search-criteria',path: '/jobs/search-criteria',getParentRoute: () => rootRouteImport
          })
const ResumesIndexRoute = ResumesIndexRouteImport.update({
            id: '/resumes/',path: '/resumes/',getParentRoute: () => rootRouteImport
          })
const ResumesResumeIdRoute = ResumesResumeIdRouteImport.update({
            id: '/resumes/$resumeId',path: '/resumes/$resumeId',getParentRoute: () => rootRouteImport
          })
const ResumesNewRoute = ResumesNewRouteImport.update({
            id: '/resumes/new',path: '/resumes/new',getParentRoute: () => rootRouteImport
          })
const SalaryIndexRoute = SalaryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SalaryRoute
          })
const SalaryNegotiateRoute = SalaryNegotiateRouteImport.update({
            id: '/negotiate',path: '/negotiate',getParentRoute: () => SalaryRoute
          })
const SharedShareTokenRoute = SharedShareTokenRouteImport.update({
            id: '/shared/$shareToken',path: '/shared/$shareToken',getParentRoute: () => rootRouteImport
          })
const SkillsIndexRoute = SkillsIndexRouteImport.update({
            id: '/skills/',path: '/skills/',getParentRoute: () => rootRouteImport
          })
const SkillsOccupationRoute = SkillsOccupationRouteImport.update({
            id: '/skills/$occupation',path: '/skills/$occupation',getParentRoute: () => rootRouteImport
          })
const UniSlugRoute = UniSlugRouteImport.update({
            id: '/uni/$slug',path: '/uni/$slug',getParentRoute: () => rootRouteImport
          })
const UniversityIndexRoute = UniversityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UniversityRoute
          })
const UniversityDashboardRoute = UniversityDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => UniversityRoute
          })
const BlogCitiesSlugRoute = BlogCitiesSlugRouteImport.update({
            id: '/blog/cities/$slug',path: '/blog/cities/$slug',getParentRoute: () => rootRouteImport
          })
const BlogCountriesCodeRoute = BlogCountriesCodeRouteImport.update({
            id: '/blog/countries/$code',path: '/blog/countries/$code',getParentRoute: () => rootRouteImport
          })
const BlogPillarSlugRoute = BlogPillarSlugRouteImport.update({
            id: '/blog/pillar/$slug',path: '/blog/pillar/$slug',getParentRoute: () => rootRouteImport
          })
const BlogRolesSlugRoute = BlogRolesSlugRouteImport.update({
            id: '/blog/roles/$slug',path: '/blog/roles/$slug',getParentRoute: () => rootRouteImport
          })
const BlogTagsTagRoute = BlogTagsTagRouteImport.update({
            id: '/blog/tags/$tag',path: '/blog/tags/$tag',getParentRoute: () => rootRouteImport
          })
const BlogUniversitiesSlugRoute = BlogUniversitiesSlugRouteImport.update({
            id: '/blog/universities/$slug',path: '/blog/universities/$slug',getParentRoute: () => rootRouteImport
          })
const BlogVisaSlugRoute = BlogVisaSlugRouteImport.update({
            id: '/blog/visa/$slug',path: '/blog/visa/$slug',getParentRoute: () => rootRouteImport
          })
const GehaltBerufBundeslandRoute = GehaltBerufBundeslandRouteImport.update({
            id: '/$bundesland',path: '/$bundesland',getParentRoute: () => GehaltBerufRoute
          })





const AnalyticsRouteChildren = {
  AnalyticsActivityRoute: AnalyticsActivityRoute,AnalyticsResumePerformanceRoute: AnalyticsResumePerformanceRoute,AnalyticsIndexRoute: AnalyticsIndexRoute
}

const AnalyticsRouteWithChildren = AnalyticsRoute._addFileChildren(AnalyticsRouteChildren)




const CoverLettersRouteChildren = {
  CoverLettersCoverIdRoute: CoverLettersCoverIdRoute
}

const CoverLettersRouteWithChildren = CoverLettersRoute._addFileChildren(CoverLettersRouteChildren)




const InterviewPrepRouteChildren = {
  InterviewPrepPracticeRoute: InterviewPrepPracticeRoute,InterviewPrepQuestionBankRoute: InterviewPrepQuestionBankRoute,InterviewPrepIndexRoute: InterviewPrepIndexRoute
}

const InterviewPrepRouteWithChildren = InterviewPrepRoute._addFileChildren(InterviewPrepRouteChildren)




const SalaryRouteChildren = {
  SalaryNegotiateRoute: SalaryNegotiateRoute,SalaryIndexRoute: SalaryIndexRoute
}

const SalaryRouteWithChildren = SalaryRoute._addFileChildren(SalaryRouteChildren)




const UniversityRouteChildren = {
  UniversityDashboardRoute: UniversityDashboardRoute,UniversityIndexRoute: UniversityIndexRoute
}

const UniversityRouteWithChildren = UniversityRoute._addFileChildren(UniversityRouteChildren)




const GehaltBerufRouteChildren = {
  GehaltBerufBundeslandRoute: GehaltBerufBundeslandRoute
}

const GehaltBerufRouteWithChildren = GehaltBerufRoute._addFileChildren(GehaltBerufRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AgbRoute: AgbRoute,AnalyticsRoute: AnalyticsRouteWithChildren,ApplicationsRoute: ApplicationsRoute,BarrierefreiheitRoute: BarrierefreiheitRoute,BillingRoute: BillingRoute,CoverLettersRoute: CoverLettersRouteWithChildren,DashboardRoute: DashboardRoute,DatenschutzRoute: DatenschutzRoute,DeepMatchRoute: DeepMatchRoute,FeedbackRoute: FeedbackRoute,HelpRoute: HelpRoute,ImpressumRoute: ImpressumRoute,InterviewPrepRoute: InterviewPrepRouteWithChildren,KeywordOptimizerRoute: KeywordOptimizerRoute,KuendigungRoute: KuendigungRoute,LoginRoute: LoginRoute,NegotiationRoute: NegotiationRoute,OnboardingRoute: OnboardingRoute,PortalScannerRoute: PortalScannerRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ReferralRoute: ReferralRoute,RegisterRoute: RegisterRoute,SalaryRoute: SalaryRouteWithChildren,SettingsRoute: SettingsRoute,StoryBankRoute: StoryBankRoute,UniversityRoute: UniversityRouteWithChildren,VpatRoute: VpatRoute,WiderrufRoute: WiderrufRoute,AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignupRoute: AuthSignupRoute,BlogSlugRoute: BlogSlugRoute,DeAtsLebenslaufAnforderungenBelegenRoute: DeAtsLebenslaufAnforderungenBelegenRoute,DeLebenslaufGeneratorDin5008Route: DeLebenslaufGeneratorDin5008Route,EnChancenkarteResumeBuilderRoute: EnChancenkarteResumeBuilderRoute,GehaltBerufRoute: GehaltBerufRouteWithChildren,JobsJobIdRoute: JobsJobIdRoute,JobsNewRoute: JobsNewRoute,JobsScrapedRoute: JobsScrapedRoute,JobsSearchCriteriaRoute: JobsSearchCriteriaRoute,ResumesResumeIdRoute: ResumesResumeIdRoute,ResumesNewRoute: ResumesNewRoute,SharedShareTokenRoute: SharedShareTokenRoute,SkillsOccupationRoute: SkillsOccupationRoute,UniSlugRoute: UniSlugRoute,BlogIndexRoute: BlogIndexRoute,GehaltIndexRoute: GehaltIndexRoute,JobsIndexRoute: JobsIndexRoute,ResumesIndexRoute: ResumesIndexRoute,SkillsIndexRoute: SkillsIndexRoute,BlogCitiesSlugRoute: BlogCitiesSlugRoute,BlogCountriesCodeRoute: BlogCountriesCodeRoute,BlogPillarSlugRoute: BlogPillarSlugRoute,BlogRolesSlugRoute: BlogRolesSlugRoute,BlogTagsTagRoute: BlogTagsTagRoute,BlogUniversitiesSlugRoute: BlogUniversitiesSlugRoute,BlogVisaSlugRoute: BlogVisaSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)